import { useTimelineContext } from 'dnd-timeline';
import { mytClock, nowVisible } from './dropLogic.js';

/** 316 — the now-line, drawn only while now falls inside the view. */
export function NowMarker({ now }: { now: number }) {
  const { range, valueToPixels, sidebarWidth } = useTimelineContext();
  if (!nowVisible(now, range)) return null;
  return (
    <div
      data-testid="schedule-now"
      role="img"
      aria-label={`Now, ${mytClock(now)}`}
      className="pointer-events-none absolute top-0 bottom-0 z-20 w-0.5 bg-brand-yellow"
      style={{ left: sidebarWidth + valueToPixels(now - range.start) }}
    />
  );
}
